import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const createAssignment = async (payload) => {
  const response = await fetch(`${API_URL}/api/Assignments`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to create batch");
  }

  return await response.json(); // Yeh response me batch ka _id hoga
};

export const fetchAssignments = async (page, pageSize) => {
  try {
    const res = await fetch(`${API_URL}/api/Assignments?page=${page}&limit=${pageSize}`);
    const response = await res.json();

    // ✅ Return full response object including pagination
    return {
      data: response.data,
      pagination: response.pagination,
    };
  } catch (error) {
    throw error;
  }
};
export const fetchAssignmentsByBatchId = async (batchId) => {
  const res = await fetch(`${API_URL}/api/Assignments?batchId=${batchId}&pageSize=500`);
  const response = await res.json();
  return response.data || [];
};

export const fetchAssignmentById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/api/Assignments/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// Fetches question objects for the IDs stored on an assignment.
// Falls back to a large page fetch + client-side filter if the backend
// doesn't expose a bulk-ID query param.
export const fetchQuestionsForAssignment = async (questionIds) => {
  if (!questionIds?.length) return [];
  try {
    const idSet = new Set(questionIds);
    const params = new URLSearchParams();
    params.append("pageSize", 500);
    const res = await fetch(`${API_URL}/api/questions?${params.toString()}`);
    const response = await res.json();
    return (response.data || []).filter(q => idSet.has(q._id));
  } catch {
    return [];
  }
};